import React from "react";

import {OfferType} from "../../../offer/types/OfferType";
import {SiteMapOffersType} from "./SiteMapOffersType";

export const SiteMapHouseOffers = () => <SiteMapOffersType offerType={OfferType.HOUSE} />;
import React from "react";

import {OfferType} from "../../../offer/types/OfferType";
import {SiteMapOffersType} from "./SiteMapOffersType";

export const SiteMapHouseOffers = () => <SiteMapOffersType offerType={OfferType.HOUSE} />;
